<script>
    // Importa el componente ProyectoView desde su respectiva ubicación
    import PrecioView from "../../viewsERP/PrecioView.svelte";
</script>

<div class="flex flex-wrap mt-4">
    <div class="w-full mb-12 px-4">
        <PrecioView />
    </div>
</div>
